"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsTableConf = void 0;
var formatRelative_1 = __importDefault(require("date-fns/formatRelative"));
var constants_1 = require("containers/TableMaker/constants");
var formatters_1 = require("utils/formatters");
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
exports.paymentsTableConf = {
    headersMap: {
        provider: 'Platform',
        organizationName: 'Organization',
        connectedOn: 'Connected',
    },
    extractors: {
        connectedOn: function (item) { return item.connectedOn && (0, formatRelative_1.default)(item.connectedOn.toDate(), new Date()); },
    },
    cells: [
        { cell: { width: MD }, field: 'provider' },
        { cell: { width: LG, growCell: true, offset: 'right' }, field: 'organizationName' },
        { cell: { width: MD, textAlign: 'center' }, field: 'currency' },
        { cell: { width: MD + 16 }, field: 'connectedOn' },
        { cell: { width: SM + XS, textAlign: 'right' }, field: 'status', renderField: formatters_1.camelToProper },
    ],
};
